import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';
import { createStore } from './store.js';

/* Plugins */

import nuxt_plugin_appplugin_28eea43a from 'nuxt_plugin_appplugin_28eea43a'; // Source: ../node_modules/.pnpm/@nuxt+bridge-edge@3.0.0-27998567.a12a710_@babel+core@7.21.4_supports-color@7.2.0__@type_3cdde109b040e1e4bd3c3bb4826c52c3/node_modules/@nuxt/bridge-edge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_89bb4dd6 from 'nuxt_plugin_configplugin_89bb4dd6'; // Source: ../node_modules/.pnpm/@nuxt+bridge-edge@3.0.0-27998567.a12a710_@babel+core@7.21.4_supports-color@7.2.0__@type_3cdde109b040e1e4bd3c3bb4826c52c3/node_modules/@nuxt/bridge-edge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_nitrobridgeserver_1ab611b4 from 'nuxt_plugin_nitrobridgeserver_1ab611b4'; // Source: ./nitro-bridge.server.mjs (mode: 'server')
import nuxt_plugin_nitrobridgeclient_6d7d5b88 from 'nuxt_plugin_nitrobridgeclient_6d7d5b88'; // Source: ./nitro-bridge.client.mjs (mode: 'client')
import nuxt_plugin_pluginutils_ea6a7e96 from 'nuxt_plugin_pluginutils_ea6a7e96'; // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_8dc41680 from 'nuxt_plugin_pluginrouting_8dc41680'; // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e05a2a2 from 'nuxt_plugin_pluginmain_7e05a2a2'; // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74'; // Source: ./axios.js (mode: 'all')
import nuxt_plugin_headplugin_acf7bab2 from 'nuxt_plugin_headplugin_acf7bab2'; // Source: ./webmanifest/head.plugin.js (mode: 'all')
import nuxt_plugin_capiplugin_2b56d48d from 'nuxt_plugin_capiplugin_2b56d48d'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_552efbae from 'nuxt_plugin_errorpluginserver_552efbae'; // Source: ../node_modules/.pnpm/@nuxt+bridge-edge@3.0.0-27998567.a12a710_@babel+core@7.21.4_supports-color@7.2.0__@type_3cdde109b040e1e4bd3c3bb4826c52c3/node_modules/@nuxt/bridge-edge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_router_2faddbae from 'nuxt_plugin_router_2faddbae'; // Source: ./router.js (mode: 'all')
import nuxt_plugin_01sentry_18cfd9fa from 'nuxt_plugin_01sentry_18cfd9fa'; // Source: ../plugins/01.sentry.client (mode: 'client')
import nuxt_plugin_modernizr_0f4c61a8 from 'nuxt_plugin_modernizr_0f4c61a8'; // Source: ../plugins/modernizr (mode: 'all')
import nuxt_plugin_iso3166_63aeef6d from 'nuxt_plugin_iso3166_63aeef6d'; // Source: ../plugins/iso3166 (mode: 'all')
import nuxt_plugin_routeenum_84086c0a from 'nuxt_plugin_routeenum_84086c0a'; // Source: ../plugins/route-enum (mode: 'all')
import nuxt_plugin_dayjs_35268fa2 from 'nuxt_plugin_dayjs_35268fa2'; // Source: ../plugins/dayjs (mode: 'all')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a'; // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_vueclipboard2_3c353cf9 from 'nuxt_plugin_vueclipboard2_3c353cf9'; // Source: ../plugins/vue-clipboard2 (mode: 'all')
import nuxt_plugin_tungsten_1821818c from 'nuxt_plugin_tungsten_1821818c'; // Source: ../plugins/tungsten (mode: 'all')
import nuxt_plugin_notify_4c047b82 from 'nuxt_plugin_notify_4c047b82'; // Source: ../plugins/notify (mode: 'all')
import nuxt_plugin_casl_6a7eebad from 'nuxt_plugin_casl_6a7eebad'; // Source: ../plugins/casl (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80'; // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_vueapiquery_964c47d0 from 'nuxt_plugin_vueapiquery_964c47d0'; // Source: ../plugins/vue-api-query (mode: 'all')
import nuxt_plugin_portalvue_cb5f1eca from 'nuxt_plugin_portalvue_cb5f1eca'; // Source: ../plugins/portal-vue (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e'; // Source: ../plugins/auth (mode: 'all')
import nuxt_plugin_oninitialpageload_e6119bba from 'nuxt_plugin_oninitialpageload_e6119bba'; // Source: ../plugins/on-initial-page-load (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": true,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
var originalRegisterModule = Vuex.Store.prototype.registerModule;
function registerModule(path, rawModule) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preserveState = process.client && (Array.isArray(path) ? !!path.reduce(function (namespacedState, path) {
    return namespacedState && namespacedState[path];
  }, this.state) : path in this.state);
  return originalRegisterModule.call(this, path, rawModule, _objectSpread({
    preserveState: preserveState
  }, options));
}
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
      store,
      router,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Add into store
            store[key] = app[key];

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          store = createStore(ssrContext);
          _context2.next = 5;
          return createRouter(ssrContext, config, {
            store: store
          });
        case 5:
          router = _context2.sent;
          // Add this.$router into store actions/mutations
          store.$router = router;

          // Create Root instance

          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "title": "Ausbildungsradar",
              "meta": [{
                "charset": "utf-8"
              }, {
                "name": "viewport",
                "content": "width=device-width, initial-scale=1"
              }],
              "link": [],
              "style": [],
              "script": []
            },
            store: store,
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App); // Make app available into store via this.app
          store.app = app;
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.next = 13;
          return setContext(app, {
            store: store,
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
            ssrContext: ssrContext
          });
        case 13:
          // Inject runtime config as $config
          inject('config', config);
          if (process.client) {
            // Replace store state before plugins execution
            if (window.__NUXT__ && window.__NUXT__.state) {
              store.replaceState(window.__NUXT__.state);
            }
          }

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(typeof nuxt_plugin_appplugin_28eea43a === 'function')) {
            _context2.next = 19;
            break;
          }
          _context2.next = 19;
          return nuxt_plugin_appplugin_28eea43a(app.context, inject);
        case 19:
          if (!(typeof nuxt_plugin_configplugin_89bb4dd6 === 'function')) {
            _context2.next = 22;
            break;
          }
          _context2.next = 22;
          return nuxt_plugin_configplugin_89bb4dd6(app.context, inject);
        case 22:
          if (!(process.server && typeof nuxt_plugin_nitrobridgeserver_1ab611b4 === 'function')) {
            _context2.next = 25;
            break;
          }
          _context2.next = 25;
          return nuxt_plugin_nitrobridgeserver_1ab611b4(app.context, inject);
        case 25:
          if (!(process.client && typeof nuxt_plugin_nitrobridgeclient_6d7d5b88 === 'function')) {
            _context2.next = 28;
            break;
          }
          _context2.next = 28;
          return nuxt_plugin_nitrobridgeclient_6d7d5b88(app.context, inject);
        case 28:
          if (!(typeof nuxt_plugin_pluginutils_ea6a7e96 === 'function')) {
            _context2.next = 31;
            break;
          }
          _context2.next = 31;
          return nuxt_plugin_pluginutils_ea6a7e96(app.context, inject);
        case 31:
          if (!(typeof nuxt_plugin_pluginrouting_8dc41680 === 'function')) {
            _context2.next = 34;
            break;
          }
          _context2.next = 34;
          return nuxt_plugin_pluginrouting_8dc41680(app.context, inject);
        case 34:
          if (!(typeof nuxt_plugin_pluginmain_7e05a2a2 === 'function')) {
            _context2.next = 37;
            break;
          }
          _context2.next = 37;
          return nuxt_plugin_pluginmain_7e05a2a2(app.context, inject);
        case 37:
          if (!(typeof nuxt_plugin_axios_80c87b74 === 'function')) {
            _context2.next = 40;
            break;
          }
          _context2.next = 40;
          return nuxt_plugin_axios_80c87b74(app.context, inject);
        case 40:
          if (!(typeof nuxt_plugin_headplugin_acf7bab2 === 'function')) {
            _context2.next = 43;
            break;
          }
          _context2.next = 43;
          return nuxt_plugin_headplugin_acf7bab2(app.context, inject);
        case 43:
          if (!(typeof nuxt_plugin_capiplugin_2b56d48d === 'function')) {
            _context2.next = 46;
            break;
          }
          _context2.next = 46;
          return nuxt_plugin_capiplugin_2b56d48d(app.context, inject);
        case 46:
          if (!(process.server && typeof nuxt_plugin_errorpluginserver_552efbae === 'function')) {
            _context2.next = 49;
            break;
          }
          _context2.next = 49;
          return nuxt_plugin_errorpluginserver_552efbae(app.context, inject);
        case 49:
          if (!(typeof nuxt_plugin_router_2faddbae === 'function')) {
            _context2.next = 52;
            break;
          }
          _context2.next = 52;
          return nuxt_plugin_router_2faddbae(app.context, inject);
        case 52:
          if (!(process.client && typeof nuxt_plugin_01sentry_18cfd9fa === 'function')) {
            _context2.next = 55;
            break;
          }
          _context2.next = 55;
          return nuxt_plugin_01sentry_18cfd9fa(app.context, inject);
        case 55:
          if (!(typeof nuxt_plugin_modernizr_0f4c61a8 === 'function')) {
            _context2.next = 58;
            break;
          }
          _context2.next = 58;
          return nuxt_plugin_modernizr_0f4c61a8(app.context, inject);
        case 58:
          if (!(typeof nuxt_plugin_iso3166_63aeef6d === 'function')) {
            _context2.next = 61;
            break;
          }
          _context2.next = 61;
          return nuxt_plugin_iso3166_63aeef6d(app.context, inject);
        case 61:
          if (!(typeof nuxt_plugin_routeenum_84086c0a === 'function')) {
            _context2.next = 64;
            break;
          }
          _context2.next = 64;
          return nuxt_plugin_routeenum_84086c0a(app.context, inject);
        case 64:
          if (!(typeof nuxt_plugin_dayjs_35268fa2 === 'function')) {
            _context2.next = 67;
            break;
          }
          _context2.next = 67;
          return nuxt_plugin_dayjs_35268fa2(app.context, inject);
        case 67:
          if (!(typeof nuxt_plugin_veevalidate_6e5ad03a === 'function')) {
            _context2.next = 70;
            break;
          }
          _context2.next = 70;
          return nuxt_plugin_veevalidate_6e5ad03a(app.context, inject);
        case 70:
          if (!(typeof nuxt_plugin_vueclipboard2_3c353cf9 === 'function')) {
            _context2.next = 73;
            break;
          }
          _context2.next = 73;
          return nuxt_plugin_vueclipboard2_3c353cf9(app.context, inject);
        case 73:
          if (!(typeof nuxt_plugin_tungsten_1821818c === 'function')) {
            _context2.next = 76;
            break;
          }
          _context2.next = 76;
          return nuxt_plugin_tungsten_1821818c(app.context, inject);
        case 76:
          if (!(typeof nuxt_plugin_notify_4c047b82 === 'function')) {
            _context2.next = 79;
            break;
          }
          _context2.next = 79;
          return nuxt_plugin_notify_4c047b82(app.context, inject);
        case 79:
          if (!(typeof nuxt_plugin_casl_6a7eebad === 'function')) {
            _context2.next = 82;
            break;
          }
          _context2.next = 82;
          return nuxt_plugin_casl_6a7eebad(app.context, inject);
        case 82:
          if (!(typeof nuxt_plugin_axios_3566aa80 === 'function')) {
            _context2.next = 85;
            break;
          }
          _context2.next = 85;
          return nuxt_plugin_axios_3566aa80(app.context, inject);
        case 85:
          if (!(typeof nuxt_plugin_vueapiquery_964c47d0 === 'function')) {
            _context2.next = 88;
            break;
          }
          _context2.next = 88;
          return nuxt_plugin_vueapiquery_964c47d0(app.context, inject);
        case 88:
          if (!(typeof nuxt_plugin_portalvue_cb5f1eca === 'function')) {
            _context2.next = 91;
            break;
          }
          _context2.next = 91;
          return nuxt_plugin_portalvue_cb5f1eca(app.context, inject);
        case 91:
          if (!(typeof nuxt_plugin_auth_6a7e4e1e === 'function')) {
            _context2.next = 94;
            break;
          }
          _context2.next = 94;
          return nuxt_plugin_auth_6a7e4e1e(app.context, inject);
        case 94:
          if (!(typeof nuxt_plugin_oninitialpageload_e6119bba === 'function')) {
            _context2.next = 97;
            break;
          }
          _context2.next = 97;
          return nuxt_plugin_oninitialpageload_e6119bba(app.context, inject);
        case 97:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // Wait for async component to be resolved first
          _context2.next = 100;
          return new Promise(function (resolve, reject) {
            // Ignore 404s rather than blindly replacing URL in browser
            if (process.client) {
              var _router$resolve = router.resolve(app.context.route.fullPath),
                _route = _router$resolve.route;
              if (!_route.matched.length) {
                return resolve();
              }
            }
            router.replace(app.context.route.fullPath, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (process.server && ssrContext && ssrContext.url) {
                          ssrContext.url = to.fullPath;
                        }
                        _context.next = 3;
                        return getRouteData(to);
                      case 3:
                        app.context.route = _context.sent;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 100:
          return _context2.abrupt("return", {
            store: store,
            app: app,
            router: router
          });
        case 101:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };